import {useState} from 'react'
import { MdEdit, MdZoomIn } from 'react-icons/md'
import { IoMdClose } from 'react-icons/io'
const KLM = (props) => {
    const {OPQ, RST} = props
    return (
    <div className='modal'>
    <div className='modal-content'>
    <div className='text-right'><button className='plane-btn' onClick={OPQ}><IoMdClose/></button></div>
    {RST.item}
    </div>
    </div>
    )
} 
export default function ABC() {
    const [ABC, setABC] = useState([])
    const [DEF, setDEF] = useState({})
    const [GHI, setGHI] = useState('')
    const [JKL, setJKL] = useState('')
    const [MNO, setMNO] = useState(false)
    const PQR = (e) => { 
      setGHI(e.target.value)
    } 
    const STU = () => { 
      setABC(ABC.concat({
        id:Math.random().toString(36).substring(2),
        item:GHI
      }))
    }
    const VWX = (e) => {
      setJKL({...JKL, item:e.target.value})
      console.log('input1',JKL)
    }
    const YZA = (e) => {
      e.preventDefault()
      const x = ABC.filter(y => y.id === JKL.id)[0]
      const w = ABC.indexOf(x)
      //copy current ABC
      var z = [...ABC]
      z[w] = {...z[w] , item:JKL.item}
      setABC(z)
      setJKL('')
    }
    const BCD = (x) =>{
        setDEF(x)
        setMNO(!MNO)
    }
    const EFG = () =>{
        setMNO(!MNO)
    }
    const HIJ = (y) => { 
      setABC((x) => {
        return x.filter((x) => x.id !== y)
        })
    } 
      return (
        <>
        <div className='flex'>
         <input type='text' value={GHI} onChange={(x)=>PQR(x)} className='w-[200px] border border-gray-950'/>
         <button className='primary-btn ml-1' onClick={STU}>+</button>
        </div>
          {ABC.map((x)=> (
          <div className='flex'>
          {JKL.id === x.id ?<> <input type='text' onChange={VWX} defaultValue={JKL.item} value={JKL.item} className='border border-gray-950'/><button className="plane-btn ml-1" onClick={(e) => YZA(e)}>Save</button><button className='plane-btn ml-2' onClick={() => setJKL('')}>cancel</button><b/></> :
          <>
            {x.item}<button className="plane-btn ml-1" onClick={() => setJKL(x)}><MdEdit /></button><button className="plane-btn ml-1" onClick={()=> BCD(x)}><MdZoomIn/></button><button className='plane-btn ml-1' onClick={()=>HIJ(x.id)}><IoMdClose/></button></>}</div>
          ))}
          {MNO ? 
          <KLM OPQ={EFG} RST={DEF} />:''}
        </>
      )
  }
